import { isValidElement, ReactNode } from "react";
import { CustomerResponse } from "../../../types/customer.type";
import { customerStatusDisplay } from "../data";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import Paper from "@mui/material/Paper";
import Grid from "@mui/material/Grid";

interface ContactInfoProps {
  customerDetails: CustomerResponse;
}

interface DetailsProps {
  label: string;
  value: string | number | ReactNode;
}

const GrayText = ({ children }: { children: ReactNode }) => (
  <Typography
    variant="caption"
    sx={{ color: (theme) => theme.palette.gray.main }}
  >
    {children}
  </Typography>
);

const Details = ({ label, value }: DetailsProps) => (
  <>
    <Grid size={4}>
      <Typography variant="caption" fontWeight={600}>
        {label}
      </Typography>
    </Grid>
    <Grid size={6}>
      {isValidElement(value) ? value : <GrayText>{value}</GrayText>}
    </Grid>
    <Grid size={2} />
  </>
);

export default function ContactInfo({ customerDetails }: ContactInfoProps) {
  return (
    <Paper sx={{ padding: "16px 24px", mt: 3 }}>
      <Grid container>
        <Grid size={6}>
          <Typography variant="caption" color="primary" fontWeight={700}>
            ข้อมูลติดต่อ
          </Typography>
          <Grid container>
            {/* The value is the shop's route number, never a salesperson — it was
                labelled "พนักงานขาย" only because the API field was called emp_code. */}
            <Details label="สายส่ง" value={customerDetails.route_number} />
            <Details
              label="ชื่อผู้ติดต่อ"
              value={customerDetails.contact_name}
            />
            <Details
              label="เปิดใช้งานสูตร"
              value={
                <Box sx={{ display: "flex", alignItems: "center", mt: "4px" }}>
                  <Box
                    sx={{
                      width: 10,
                      height: 10,
                      borderRadius: "50%",
                      bgcolor: (theme) =>
                        theme.palette[
                          customerStatusDisplay(customerDetails.status).color
                        ].main,
                      mr: 1,
                    }}
                  />
                  <GrayText>
                    {customerStatusDisplay(customerDetails.status).label}
                  </GrayText>
                </Box>
              }
            />
          </Grid>
        </Grid>

        <Grid size={6}>
          <Typography variant="caption" color="primary" fontWeight={700}>
            ที่อยู่ลูกค้า
          </Typography>
          <Grid container>
            <Details label="ที่อยู่" value={"-"} />
            <Details label="ละติจูด" value={customerDetails.latitude ?? "-"} />
            <Details label="ลองติจูด" value={customerDetails.longitude ?? "-"} />
          </Grid>
        </Grid>
      </Grid>
    </Paper>
  );
}
